import { render, staticRenderFns } from "./QuickBrand.vue?vue&type=template&id=f5512908&scoped=true&"
import script from "./QuickBrand.vue?vue&type=script&lang=js&"
export * from "./QuickBrand.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./QuickBrand.vue?vue&type=style&index=1&id=f5512908&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5512908",
  null
  
)

export default component.exports